import { CONSTANTS, HUMANIZER_OPTIONS, NULL_USER, READING_LEVEL_OPTIONS, TYPE_OPTIONS } from '../constants'
import { DocumentState, Documents, REF_STYLES, SystemState, UserWriterSelections } from './types'

export const writingStyleDescriptions = {
	Standard: 'College reading level with an academic tone.',
	Academic: 'College reading level with an academic tone.',
	Professional: 'Professional tone with a business focus.',
	Casual: 'Conversational tone with a casual style.',
	Creative: 'Creative tone with a storytelling style.',
}

export const blankUserWriterSelections: UserWriterSelections = {
	wordCount: 250,
	refStyle: 'APA_7' as REF_STYLES,
	type: TYPE_OPTIONS[0],
	readingLevel: READING_LEVEL_OPTIONS[READING_LEVEL_OPTIONS.length - 2],
	humanizerIntensity: HUMANIZER_OPTIONS[0],
	subTopics: [],
	thesisStatement: {
		text: '',
		active: false,
	},
	writingStyle: {
		name: 'Standard',
		generalSelected: true,
	},
}

export const newDocument: DocumentState = {
	setup: true,
	setupChanged: false,
	content: CONSTANTS.EMPTY_DOCUMENT,
	drafts: [],
	jsonContent: {},
	title: '',
	humanized: null,
	lastSavedContent: '',
	lastSavedTitle: '',
	userWriterSelections: blankUserWriterSelections,
	isGenerating: false,
	isGeneratingSubtopics: false,
	isHumanizing: false,
	needsHumanizing: false,
	isTypingAddMore: false,
	isTypingEssay: false,
	isOnSubtopicsStep: false,
	references: [],
	allReferences: [],
	generatingReferences: false,
}

export const initialDocumentsState: Documents = {
	'': newDocument, //If urls param id is undefined, then docID prop will be ''
}

export const initialSystemState: SystemState = {
	showNav: true,
	lastAggregatePageVisited: '/blog',
	user: NULL_USER,
	userLoading: true,
	userPagesCache: { source: 'cookies', pages: [], dirty: false },
	userPagesLoading: false,
	tiptapJWToken: undefined,
	graderModeOn: false,
	selectedGraderCategory: 'grammar',
	categoryScoresLoading: false,
	numAcceptedSuggestions: 0,
}
